// 甲寄于寅，乙寄于辰，直至壬寄于亥，癸寄于丑，四正位（子、午、卯、酉）不寄
export const JiGong = {
    "甲": "寅",
    "乙": "辰",
    "丙": "巳",
    "戊": "巳",
    "丁": "未",
    "己": "未",
    "庚": "申",
    "辛": "戌",
    "壬": "亥",
    "癸": "丑"
}